import { render, staticRenderFns } from "./CardBasicDecks.vue?vue&type=template&id=3dbf6884"
import script from "./CardBasicDecks.vue?vue&type=script&lang=js"
export * from "./CardBasicDecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports